// True only under `npm start`. Every `npm run build` (staging and production deploys) has NODE_ENV=production.
export const isLocal = process.env.NODE_ENV === 'development';
